export default __webpack_public_path__ + "static/media/contact-icon.b0d281f3.svg";